import { FC, PropsWithChildren } from 'react';
import { get } from 'lodash';

import classNames from 'classnames';
import { useTheme } from 'styled-components';
import { useContextSelector } from 'use-context-selector';

import { ContentFixed } from '../ContentFixed/ContentFixed';
import { PageContext } from '../../../contexts/PageContext';

import { ContentSubheaderGap } from './ContentSubheader.types';

import styles from './ContentSubheader.module.scss';

type ContentSubheaderProps = PropsWithChildren<{
  className?: string;
  divider?: boolean;
  gap?: ContentSubheaderGap;
  sticky?: boolean;
}>;

export const ContentSubheader: FC<ContentSubheaderProps> = ({
  className,
  divider,
  gap = 'sm',
  children,
  sticky = false,
}) => {
  const { palette, gradient } = useTheme();

  const headerBackground = useContextSelector(
    PageContext,
    ({ headerBackground }) => headerBackground
  );

  return (
    <div
      style={{ background: get(palette, headerBackground) }}
      className={classNames(
        styles.root,
        className,
        get(gradient, headerBackground),
        'ion-no-border',
        {
          [styles.divider]: divider,
          [styles.sticky]: sticky,
        }
      )}
    >
      <ContentFixed className={classNames(styles.content, styles[gap])}>
        {children}
      </ContentFixed>
    </div>
  );
};
